<template>
  <v-col style="margin-bottom:50px;margin-top:60px">
    <v-row justify="center">
      <v-card class="mx-3 px-3 mb-4 white--text transparent" flat>
        <div style="line-height:45px; font-size:20px">
          <div style="display:inline-block;position:relative" class="font-weight-bold mr-3 ml-1">
            {{customer.name}}
            <div
              class="winking"
              style="animation-duration: 2.5s;font-size:14px;position:absolute;transform:rotate(30deg);top:-20px;right:-14px;"
            >💓</div>
            <div
              class="winking"
              style="animation-duration: 3s;font-size:10px;position:absolute;transform:rotate(-40deg);top:-18px;left:-14px;"
            >💓</div>
            <div
              class="winking"
              style="animation-duration: 3.5s;font-size:14px;position:absolute;transform:rotate(40deg);bottom:-20px;right:-10px;"
            >💓</div>
            <div
              class="winking"
              style="animation-duration: 4s;font-size:12px;position:absolute;transform:rotate(-30deg);bottom:-18px;left:-10px;"
            >💓</div>
          </div>loyalty card 👑
        </div>
      </v-card>
    </v-row>
    <v-row justify="center">
      <v-col style="max-width:350px">
        <v-row>
          <v-col v-for="(card, index) in cards" :key="index" :cols="card.flex">
            <v-card>
              <v-img
                :src="customer.logoUrl"
                class="white--text align-end"
                style="position:relative; opacity:0.8"
                :class="{'primary activated': user.credits > index, secondary:  user.credits <= index}"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              >
                <div
                  style="text-shadow:0px 2px 2px black;font-size:20px;text-align:center;position:absolute;top:0;bottom:0;display: flex;align-items:center;justify-content:center;"
                >{{card.text}}</div>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["customer"])
  },
  data: () => ({
    user: { credits: 2 },
    cards: [
      {
        flex: 4
      },
      {
        flex: 4
      },
      {
        flex: 4
      },
      {
        flex: 4
      },
      {
        flex: 4
      },
      {
        flex: 4
      },
      {
        flex: 4
      },
      {
        flex: 4
      },
      {
        text: "1 free coffee",
        flex: 4
      }
    ]
  })
};
</script>

<style>
.activated {
  opacity: 1 !important;
}
.winking {
  animation-name: wink;
  animation-iteration-count: infinite;
  animation-duration: 2s;
}
@keyframes wink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>

